import React from 'react';
import { Token } from '@/pages/race-wizard';

export const SelectedTokensList = ({
  tokens,
  handleTokenSelect,
}: {
  tokens: Token[];
  handleTokenSelect: (token: Token) => void;
}) => {
  if (tokens.length === 0) return null;

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="text-sm">Selected Tokens</div>
      <div className="flex w-full flex-wrap items-center justify-center gap-4 font-medium md:gap-8">
        {tokens.map((token, index) => (
          <React.Fragment key={token.id}>
            <div className="token-item" onClick={() => handleTokenSelect(token)} title={`Remove ${token.name}`}>
              <div className="flex items-center justify-center overflow-hidden rounded-full">
                <img src={token.image} alt={`${token.id}`} className="size-6 object-contain md:size-10 lg:size-16" />
              </div>
            </div>
            {index < tokens.length - 1 && <div className="vs-separator">VS</div>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
